import { AccountStatus, IInvoice, IPrice, IStripePaymentItem } from '../payments';
import { BaseUserProfile } from '../users/BaseUserProfile';
import { ISpecialOfferDisplay } from './SpecialOffer';
import { UserAccountInfo } from './UserAccountInfo';

export interface IUserInfo extends UserAccountInfo {
    shippingAddress: any;
    profile: BaseUserProfile;
    currency: string | null;
    activeSpecialOffer?: ISpecialOfferDisplay;
    specialOfferEnabled: boolean;
    hasAccessToAStudioGym: boolean;
    currentAccountStatus?: AccountStatus;
    currentSubscriptionPeriodEnd?: number;
    validPlansForSubscription?: IPrice[];
    standardMembershipPlansLink?: string;
}

export class UserAccountDetail {
    public userInfo: IUserInfo;
    public payments?: IStripePaymentItem[];
    public invoices?: IInvoice[];
}
